import { Horse_show } from './horse_show';
import { Horse_show_entry } from './horse_show_entry';
import { Sms_order } from './sms_order';
import { User } from './user';

export class Submitted_entries_cheque_receipt {
	confirmation_code: string;
	order_id: string;
	order_map: Sms_order[];
	horse_show: Horse_show;
	horse_show_entry_list: Horse_show_entry[];
	user: User;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}